import { ScrollArea } from '@/components/ui/scroll-area';
import { Button } from '@/components/ui/button';
import { PlusCircle, MinusCircle } from 'lucide-react';

type AssetItem = {
  name: string;
  id: string;
};

type AssetSelectorProps = {
  available: AssetItem[];
  selected: AssetItem[];
  onAdd: (assetType: string) => void;
  onRemove: (assetType: string) => void;
};

export const AssetSelector = ({
  available,
  selected,
  onAdd,
  onRemove,
}: AssetSelectorProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
      <div className="border rounded-lg h-96 flex flex-col">
        <h4 className="font-semibold p-3 border-b">Available</h4>
        <ScrollArea className="flex-1 p-2 min-h-0">
          {available.map(({ id, name }) => (
            <div
              key={id}
              className="flex justify-between items-center p-2 hover:bg-muted rounded"
            >
              <span className="capitalize">{name}</span>
              <Button
                size="icon"
                variant="ghost"
                className="h-8 w-8 text-secondary hover:bg-muted"
                onClick={() => onAdd(id)}
                type="button"
              >
                <PlusCircle className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </ScrollArea>
      </div>

      {/* Associated Asset Types List */}
      <div className="border rounded-lg h-96 flex flex-col">
        <h4 className="font-semibold p-3 border-b">Associated Types</h4>
        <ScrollArea className="flex-1 p-2 min-h-0">
          {selected.map(({ id, name }) => (
            <div
              key={id}
              className="flex justify-between items-center p-2 hover:bg-muted rounded"
            >
              <div>
                <span className="capitalize font-medium">{name}</span>
              </div>
              <Button
                size="icon"
                variant="ghost"
                className="h-8 w-8 text-muted-foreground hover:text-secondary"
                onClick={() => onRemove(id)}
                type="button"
              >
                <MinusCircle className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </ScrollArea>
      </div>
    </div>
  );
};
